export const mlCopyBlockMockData = {
  title: 'Lorem Ipsum Title',
};
